import { render, staticRenderFns } from "./Superuser.vue?vue&type=template&id=d9919de6&"
import script from "./Superuser.vue?vue&type=script&lang=js&"
export * from "./Superuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports